import { Form, Input, message, Select, Spin } from "antd";

import React, { useState } from "react";
import Button from "../../components/Button";
import { AllDeveloper, UpdateDeveloper, createDeveloper } from "./service";
import { useDispatch, useSelector } from "react-redux";
import { setDeveloperLoading } from "../../actions/DeveloperActions";

export const AddDeveloperForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const state = useSelector((state) => state.developerState);
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const handleSubmit = async (values) => {
    setLoading(true);
    dispatch(setDeveloperLoading(true));
    await createDeveloper(dispatch, values, image);
    await AllDeveloper(dispatch);
    dispatch(setDeveloperLoading(false));
    setLoading(false);
  };
  const handleEdit = async (values) => {
    setLoading(true);
    dispatch(setDeveloperLoading(true));
    await UpdateDeveloper(dispatch, values, state?.viewModal?.data?.id);
    await AllDeveloper(dispatch);
    dispatch(setDeveloperLoading(false));
    setLoading(false);
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  return (
    <Spin spinning={loading}>
      <div className="flex flex-col items-center justify-center items-center  text-xl">
        {!state?.viewModal?.visible && <span>Add New Developer</span>}
        {state?.viewModal?.visible && <span>Edit Developer</span>}

        <Form
          onFinish={state?.viewModal?.visible ? handleEdit : handleSubmit}
          form={form}
          layout="vertical"
          style={{ width: "85%", marginTop: "50px" }}
          initialValues={{
            name: state?.viewModal?.visible ? state?.viewModal?.data?.name : "",
            designation: state?.viewModal?.visible
              ? state?.viewModal?.data?.designation
              : "",
            color: state?.viewModal?.visible
              ? state?.viewModal?.data?.color
              : "",
            linkedIn_URL: state?.viewModal?.visible
              ? state?.viewModal?.data?.linkedin_url
              : "",
            status: state?.viewModal?.visible
              ? state?.viewModal?.data?.status
              : "",
          }}
        >
          <Form.Item
            name="name"
            label="Full Name"
            rules={[
              {
                required: true,
                message: `Name is required`,
              },
              {
                pattern: new RegExp(/^[A-Za-z\s]+$/),
                message: `Alphabet Only`,
              },
            ]}
          >
            <Input placeholder="FULL NAME" />
          </Form.Item>
          <Form.Item
            name="designation"
            label="Designation"
            rules={[
              {
                required: true,
                message: `Designation is required`,
              },
            ]}
          >
            <Input placeholder="Designation" />
          </Form.Item>

          <Form.Item
            name="color"
            label="Color"
            rules={[
              {
                required: true,
                message: `Color is required`,
              },
            ]}
          >
            <Input placeholder="Color" />
          </Form.Item>

          <Form.Item
            name="linkedIn_URL"
            label="LinkedIn URL"
            rules={[
              {
                required: true,
                type: "url",
                message: "This field must be a valid url.",
              },
            ]}
          >
            <Input placeholder="LinkedIn_URL" />
          </Form.Item>

          <Form.Item
            name="status"
            label="Status"
            rules={[
              {
                required: true,
                message: `Status is required`,
              },
            ]}
          >
            <Select
              placeholder="Status"
              options={[
                { label: "Active", value: "active" },
                {
                  label: "Inactive",
                  value: "inactive",
                },
              ]}
            ></Select>
          </Form.Item>

          <Form.Item
            name="image"
            label="Image Upload"
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <input
              name="image"
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e)}
            />
          </Form.Item>

          <Form.Item>
            <div>
              <Button
                label={
                  state?.viewModal?.visible
                    ? "Update Developer"
                    : "Create Developer"
                }
                type="submit"
                htmlType="submit"
              />
            </div>
          </Form.Item>
        </Form>
      </div>
    </Spin>
  );
};
